import { Environment } from "core/Environment";

import { MsalConfig } from "@bps/msal/dist/src/lib/types/msal-config.type";
import { IConfiguration } from "@microsoft/applicationinsights-web";

interface RuntimeConfig {
  appInsightsInstrumentationKey: string;
  gtmId: string;

  msal: MsalConfig;

  locale: string;
  dateFormatPattern: string;

  bhbUrl: string;
  apiUrl: string;
  fhirBaseUrl: string;
  bpxBaseUrl: string;
  bpmSystemBaseUrl: string;
  pltCatalogBaseUrl: string;
  bpCoreDocumentBaseUrl: string;
  tgApiUrl: string;
  subscriptionUrl: string;
  bpIdApiBaseUrl: string;
  PrOSHotJarSiteId: string;

  /** Environment field to drive feature toggles */
  environment: Environment;
  query: {
    staleTimeMillis: number;
  };
  appInsights?: IConfiguration;
  userInactivityTimeoutMins: number;
  syncFusionKey: string;
}

export interface AppConfig
  extends Omit<RuntimeConfig, "appInsightsInstrumentationKey"> {
  app: {
    version: string;
    commitHash: string;
  };

  signalrBaseURL: string;
  notificationDuration: number;
  appKey: string;
}

// ----- Get the appConfig as loaded from public/config.js -----
declare global {
  interface Window {
    appConfig: RuntimeConfig;
  }
}

const { appInsightsInstrumentationKey, ...runtime } = window.appConfig;
// -------------------------------------------------------------

// ----- Merge with .env settings ------------------------------
export const config: AppConfig = {
  ...runtime,

  msal: {
    ...runtime.msal,
    cacheLocation: "sessionStorage",
    postAuthenticateRedirectUrl: import.meta.env.PUBLIC_URL || "/"
  },

  appInsights: appInsightsInstrumentationKey
    ? { instrumentationKey: appInsightsInstrumentationKey }
    : undefined,

  app: {
    version: import.meta.env.VITE_VERSION as string,
    commitHash: import.meta.env.VITE_COMMIT_HASH as string
  },

  bhbUrl: import.meta.env.VITE_BHB_URL || runtime.bhbUrl,
  apiUrl: import.meta.env.VITE_API_URL || runtime.apiUrl,
  fhirBaseUrl: import.meta.env.VITE_FHIR_URL || runtime.fhirBaseUrl,
  bpxBaseUrl: import.meta.env.VITE_BPX_URL || runtime.bpxBaseUrl,
  bpmSystemBaseUrl:
    import.meta.env.VITE_BPM_SYSTEM_URL || runtime.bpmSystemBaseUrl,
  pltCatalogBaseUrl:
    import.meta.env.VITE_PLT_CATALOG_URL || runtime.pltCatalogBaseUrl,
  bpCoreDocumentBaseUrl:
    import.meta.env.VITE_BPCORE_DOCUMENT_URL || runtime.bpCoreDocumentBaseUrl,
  tgApiUrl: import.meta.env.VITE_TG_API_URL || runtime.tgApiUrl,
  subscriptionUrl:
    import.meta.env.VITE_SUBSCRIPTION_URL || runtime.subscriptionUrl,
  PrOSHotJarSiteId:
    import.meta.env.VITE_HOTJAR_SITEID || runtime.PrOSHotJarSiteId,
  signalrBaseURL: "/hubs",
  syncFusionKey: runtime.syncFusionKey,
  notificationDuration: 4000,
  appKey: `${window.location.host.replace(/[^\w\s"]/, "_")}_pros`,
  userInactivityTimeoutMins: 15
};
// -------------------------------------------------------------
